/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Gamepad_Mode_ComboInputs */



/**
* | output |
* | --- |
* | "Combined buttons (vPedal)" |
*
* @param {Options_Pedal_Gamepad_Mode_ComboInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_gamepad_mode_combo = /** @type {((inputs?: Options_Pedal_Gamepad_Mode_ComboInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Gamepad_Mode_ComboInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
	return /** @type {LocalizedString} */ ("Combined buttons (vPedal)")
});